import { doc, setDoc } from "firebase/firestore";
import { db } from "./firebaseConfig";

export const crearMembresia = async ({ pagadorId, planId }) => {
  try {
    // 🔥 1. generar token único
    const token = crypto.randomUUID();

    // 🔥 2. usar token como ID del documento
    const ref = doc(db, "membresias", token);

    // 🔥 3. guardar en Firestore
    await setDoc(ref, {
      token,
      pagadorId,
      planId,
      asignada: false,
      estadoPago: "en_verificacion",
      fechaCreacion: new Date()
    });

    // 🔥 4. devolver token (clave para el link)
    return {
      id: token,
      token
    };

  } catch (error) {
    console.error("Error creando membresía:", error);
    return null;
  }
};